import { Typography, Box, styled } from "@mui/material";

export const EntryTitle = styled(Typography)(({ theme }) => ({
    fontSize: "0.8em",
    fontWeight: 600,
    display: "flex",
    flex: 0.3,
    marginLeft: theme.spacing(1),
    marginTop: "0.8em",
}));

export const FormWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginTop: "1em",
}));

export const EntryAndLineButtonWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
}));

export const LineButtonWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "30%",
    marginTop: "1em",
}));

export const EntryWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "70%",
}));

export const EntryField = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1em",
}));

export const TimeField = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    justifyContent: "start",
    alignItems: "start",
    marginTop: "1em",
}));
